import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useFileUpload } from 'libs/common/hooks';
import { useValidators } from './useValidators';
export var useOnDrop = function useOnDrop(_ref) {
  var imageConstraints = _ref.imageConstraints,
      imageRatio = _ref.imageRatio,
      onImageDropped = _ref.onImageDropped;

  var _useFileUpload = useFileUpload(),
      loading = _useFileUpload.loading,
      doUploadFile = _useFileUpload.doUploadFile;

  var _useValidators = useValidators({
    imageConstraints: imageConstraints,
    imageRatio: imageRatio
  }),
      validators = _useValidators.validators,
      constraintErrors = _useValidators.errors,
      resetErrors = _useValidators.resetErrors;

  var onDrop = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(acceptedFiles) {
      var validateConstraints, file, url;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!((acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles[0]) === undefined)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              validateConstraints = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
                  var promise;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          promise = new Promise(function (resolve, reject) {
                            if (imageConstraints === undefined) {
                              return resolve(file);
                            }

                            var image = new Image();

                            image.onload = function () {
                              Object.keys(validators).forEach(function (constraintName) {
                                var validator = validators[constraintName];

                                if (!validator(image)) {
                                  reject(file);
                                }
                              });
                              resolve(file);
                            };

                            image.src = URL.createObjectURL(file);
                          });
                          _context.next = 3;
                          return promise.then(function () {
                            return true;
                          })["catch"](function () {
                            return false;
                          });

                        case 3:
                          return _context.abrupt("return", _context.sent);

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function validateConstraints(_x2) {
                  return _ref3.apply(this, arguments);
                };
              }(); // Reset validation state


              resetErrors();
              file = acceptedFiles[0];
              _context2.next = 7;
              return validateConstraints(file);

            case 7:
              _context2.t0 = _context2.sent;

              if (!(_context2.t0 === false)) {
                _context2.next = 11;
                break;
              }

              onImageDropped();
              return _context2.abrupt("return");

            case 11:
              _context2.next = 13;
              return doUploadFile(file);

            case 13:
              url = _context2.sent;
              onImageDropped(url);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onDrop(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    onDrop: onDrop,
    constraintErrors: constraintErrors,
    loading: loading
  };
};